import { Link, useLocation } from 'react-router-dom';
import Layout from '../layout/Layout';
import Swal from 'sweetalert2';

export default function PaymentSuccess() {
  const { state } = useLocation();

  return (
    <Layout>
      <div className="container py-5 text-center">
        <div className="card border-0 shadow p-5 d-inline-block" style={{ maxWidth: '500px' }}>
          <div className="mb-4">
            <i className="fas fa-check-circle text-success" style={{ fontSize: '5rem' }}></i>
          </div>
          <h2 className="fw-bold">Request Successful!</h2>
          <p className="text-muted">
            Your request for plan <strong>{state?.planName || 'New'}</strong> has been submitted successfully. 
            Our team will review your request and activate your plan within 24-48 hours. You will receive a confirmation email once your plan is activated.
            
          </p>
          <hr />
          <div className="d-grid gap-2">
            <Link to="/devices" className="btn btn-primary">Go to WhatsApp Devices</Link>
            <Link to="/dashboard" className="btn btn-outline-secondary">Back to Overview</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}